import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import { useRoleContext } from "hooks";

export function ShipperUpgradePage() {
  const { role, company } = useRoleContext();

  if (company == null || role?.type !== "SHIPPER") {
    return (
      <Stack alignItems="center" justifyContent="center" spacing={2}>
        <CircularProgress />
        <Typography color="error">
          {role?.type !== "SHIPPER"
            ? "Shipper role required."
            : "Loading company information..."}
        </Typography>
      </Stack>
    );
  }

  return (
    <Box
      height="100%"
      sx={{
        backgroundColor: "white",
        paddingTop: "2rem",
        borderRadius: "1rem",
        overflowY: "scroll",
      }}
    >
      <stripe-pricing-table
        style={{ height: "100%" }}
        pricing-table-id={
          import.meta.env.REACT_APP_SHIPPER_PREMIUM_LICENCE_PRICING_TABLE_ID
        }
        publishable-key={import.meta.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}
        client-reference-id={`SC${company.id}`}
      />
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        sx={{ mt: "1rem", mb: "2rem" }}
      >
        Need help? Click the chat icon in the bottom right.
      </Typography>
    </Box>
  );
}
